<section class="deals-container">
    <div class="deals-grey-bg">
        <div *ngIf="this.deals.length <= 0">
            <h1 style="color: var(--primary); font-size: 20px">
                Currently, you do not have any deals. If you believe that this is an error, please contact your sales representative.
            </h1>
        </div>

        <div *ngIf="this.deals.length > 0">
            <div class="deal-container">
                <buyer-deal-card *ngFor="let deal of deals" [deal]="deal"> </buyer-deal-card>
            </div>
        </div>
    </div>
</section>
